import { REDUCER_KEY_AUTH } from "./auth.reducer";
export var getUser = function (state) { return state.auth.user; };
export var updateUserById = function (id, state) {
    return state.auth.updateUserById[id];
};
export var isRemovingProfile = function (state) {
    return state.auth.isRemovingProfile;
};
export var isUpdatingUser = function (state) {
    return state.auth.isUpdatingUser;
};
export var removeProfileError = function (state) {
    return state.auth.removeProfileError;
};
